import React from 'react';
import { convertAmount, isMobile } from '@pascal/pascal-core';
import { globalTranslationKeys } from '../../../enums';

export const GameSpecificCheckHashPopupTopSection = ({ isFromBetHistory, currentData, t }) => {
  const { roundData, additionalParams = {} } = currentData || {};
  const { BetType } = globalTranslationKeys;
  const { start, end } = additionalParams;
  const betTypeContent =
    start && end && start !== end ? `${start} - ${end}` : start === end ? start : 0;

  return (
    <div className='jester-hat-container'>
      {isFromBetHistory && (
        <div className='history-container'>
          <div className='history-button-container'>
            <span className='history-button-text'>{t(BetType)}</span>
            <span className='history-button-text'>{betTypeContent}</span>
          </div>
        </div>
      )}
      <div className='ellipse-wrapper'>
        <div className='bottom-ellipse' />
        <div className='bottom-ellipse-main-wrapper'>
          <div className='bottom-ellipse-main'>
            <span className='ellipse-text'>{roundData}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AutoBetPopupTabContent = ({ t }) => {
  const { GAME_RULES_P11, GAME_RULES_P14, GAME_RULES_P13, GAME_RULES_P15 } = globalTranslationKeys;
  return (
    <>
      <p>
        <b>{t(GAME_RULES_P11)}</b>
      </p>
      <p>
        <b>{t(GAME_RULES_P14)}</b>
      </p>
      <p>{t(GAME_RULES_P13)}</p>
      <p>{t(GAME_RULES_P15)}</p>
    </>
  );
};
export const AboutHashInnerContent = ({ t }) => {
  return (
    <>
      {isMobile() && <p className='pr-f-text'>{t(globalTranslationKeys.FairnessModalTitle)}</p>}
      <p className='pr-f-text'>{t('FAIRNESS_P1')}</p>
      <p className='pr-f-text w-b-ba'>
        A54AC88DEF9A1FDEB29BDD6F2C691FAB92010F8B4BB5757A007E32A56AC8C0262F0E21EF8BC398F6C953A0309655665FF981361770549A8E0565A27671ABE60A
      </p>
      {new Array(10).fill('FAIRNESS_P').map((item, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <p className='pr-f-text' key={index}>
            {t(`${item}${index + 2}`)}
          </p>
        );
      })}
      <p className='pr-f-text w-b-ba'>
        A54AC88DEF9A1FDEB29BDD6F2C691FAB92010F8B4BB5757A007E32A56AC8C0262F0E21EF8BC398F6C953A0309655665FF981361770549A8E0565A27671ABE60A
      </p>
      <p className='pr-f-text'>{t('FAIRNESS_P12')}</p>
    </>
  );
};

export const HelpPopupContent = ({ t, limits, currencyCode }) => {
  const {
    Rtp,
    GAME_RULES_P1,
    GAME_RULES_P2,
    GAME_RULES_P3,
    GAME_RULES_P19,
    GAME_RULES_P12,
    GAME_RULES_P20,
    GAME_RULES_P4,
    GAME_RULES_P5,
    GAME_RULES_P6,
    GAME_RULES_P7,
    GAME_RULES_P8,
    GAME_RULES_P9,
    GAME_RULES_P10,
    GAME_RULES_P16,
    GAME_RULES_P17,
    GAME_RULES_P18,
    GAME_RULES_P21,
    GAME_RULES_P22,
    CANCELATION_MESSAGE_1,
    MALFUNCTION_MESSAGE_2,
  } = globalTranslationKeys;

  const { maxBet, minBet, maxWin } = limits;
  return (
    <>
      <p>
        <b>{t(GAME_RULES_P1)}</b>
      </p>
      <p>
        <b>{t(GAME_RULES_P2)}</b>
      </p>
      <p>
        {t(GAME_RULES_P3, {
          maxWin: convertAmount(maxWin),
          currencyCode,
        })}
      </p>
      <p>
        <b>{t(GAME_RULES_P4)}</b>
      </p>
      <p>
        <em>{t(GAME_RULES_P5)}</em>
      </p>
      <p>{t(GAME_RULES_P12)}</p>
      <p>{t(GAME_RULES_P6)}</p>
      <p>{t(GAME_RULES_P19)}</p>
      <p>{t(GAME_RULES_P7)}</p>
      <p>{t(GAME_RULES_P20)}</p>
      <p>{t(GAME_RULES_P8)}</p>
      <p>{t(GAME_RULES_P9)}</p>
      <p>{t(GAME_RULES_P10)}</p>
      <p>{t(GAME_RULES_P21)}</p>
      <p>{t(GAME_RULES_P22)}</p>
      <p>{t(GAME_RULES_P16, { minBet: convertAmount(minBet || ''), currencyCode })}</p>
      <p>{t(GAME_RULES_P17, { maxBet: convertAmount(maxBet || ''), currencyCode })}</p>
      <p>{t(GAME_RULES_P18, { maxWin: convertAmount(maxWin || ''), currencyCode })}</p>
      <p>{t(CANCELATION_MESSAGE_1)}</p>
      <p>{t(MALFUNCTION_MESSAGE_2)}</p>
      <p>{t(Rtp)}</p>
    </>
  );
};
